import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const ShortlistContext = createContext(null);
export const useShortlist = () => useContext(ShortlistContext);
const KEY = "vok_shortlist_v1";

export function ShortlistProvider({ children }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (e) {}
  }, []);

  const persist = (next) => {
    setItems(next);
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) {}
  };

  const has = useCallback((id) => items.some((i) => i.id === id), [items]);

  const toggle = useCallback((talent) => {
    setItems((prev) => {
      const exists = prev.some((i) => i.id === talent.id);
      const next = exists ? prev.filter((i) => i.id !== talent.id)
        : [...prev, { id: talent.id, name: talent.name, language: talent.language,
            country: talent.country, photo_url: talent.photo_url, age_min: talent.age_min,
            age_max: talent.age_max, voice_type: talent.voice_type }];
      try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) {}
      if (window.gtag) window.gtag("event", exists ? "removed_from_shortlist" : "added_to_shortlist");
      return next;
    });
  }, []);

  const remove = useCallback((id) => persist(items.filter((i) => i.id !== id)), [items]);
  const clear = useCallback(() => persist([]), []);

  return (
    <ShortlistContext.Provider value={{ items, has, toggle, remove, clear, count: items.length }}>
      {children}
    </ShortlistContext.Provider>
  );
}
